import { useNavigate, useParams } from 'react-router-dom';

/**
 * 带公司前缀的导航 hook
 * 自动在路径前加上 /${companySlug} 前缀
 * 
 * 用法:
 *   const navigate = useCompanyNavigate();
 *   navigate('/admin/products');  → 跳转到 /{companySlug}/admin/products
 */
export default function useCompanyNavigate() {
  const originalNavigate = useNavigate();
  const { companySlug } = useParams();

  const navigate = (to, options) => {
    let finalTo = to;
    
    if (typeof to === 'string' && companySlug) {
      // /admin/... → /{companySlug}/admin/...
      // /store/... → /{companySlug}/store/...
      // /department/... → /{companySlug}/department/...
      if (to.startsWith('/admin/') || to.startsWith('/store/') || to.startsWith('/department/')) {
        finalTo = `/${companySlug}${to}`;
      } else if (to === '/admin' || to === '/store' || to === '/department') {
        finalTo = `/${companySlug}${to}`;
      }
    }

    return originalNavigate(finalTo, options);
  };

  return navigate;
}
